import styled from 'styled-components';
import { IconButton } from '../../../../input/IconButton';
import { Flex } from '../../../../layout/Flex';
import { ViewsBadgeWrapper } from '../ViewsBadge/styles';

export const TextWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActionsTextWrapper' })
    .attrs((props) => ({
        ...props,
        flexGrow: 1,
        borderRadius: 1.5,
        opacity: 0,
        py: 0.5,
        px: 1,
        backgroundColor: 'var(--content-overlay-medium)',
        transition: '.3s ease-out',
        display: { xs: 'none', sm: 'flex' },
        maxWidth: 'calc(100% - 38px)',
    }))``;

export const ActionsWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActionsWrapper' })
    .attrs((props) => ({
        ...props,
        spacing: 1,
    }))``;

export const Button = styled(IconButton)
    .withConfig({ displayName: 'CardActionsButton' })
    .attrs((props) => ({
        ...props,
        variant: 'filled',
        size: 'm',
        padding: '6px',
        backgroundColor: 'var(--content-overlay-medium)',
    }))`
        backdrop-filter: none;
    `;

export const CardActionsWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActions' })
    .attrs((props) => ({
        ...props,
        cursor: 'pointer',
        alignItems: 'end',
        direction: 'row',
        justifyContent: 'end',
        spacing: 1,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: props.bottom || 0,
        left: 0,
        m: 1,
    }))`
        &:hover ${TextWrapper} {
            opacity: 1;
        }

        &:hover ${ViewsBadgeWrapper} {
            opacity: 0;
        }
    `;
